import { baseUrl } from "../../core/apis.js";

class FileDownloadResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  get(resource, token) {
    return this.$resource(`${baseUrl}${resource}/${token}/download_link`).get();
  }
}

export default FileDownloadResource;



// WEBPACK FOOTER //
// ./src/resources/fileDownload/fileDownload.resource.js